<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-shield"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- Card: Formulario -->
<div class="form-card-container">
  <div class="form-card">
    <div class="card-header">
      <div class="card-header-icon">
        <i class="pi pi-pencil"></i>
      </div>
      <span class="card-header-title">{{ texts.dados_do_grupo }}</span>
    </div>
    <div class="card-content">
      <div class="form-grid">
        <!-- Nome do Grupo -->
        <div class="form-field full">
          <label class="form-label">{{ labels.nome_do_grupo }} <span class="required">*</span></label>
          <input type="text" pInputText [placeholder]="placeholders.adicione_um_nome" [(ngModel)]="form.nome" class="w-full" />
        </div>

        <!-- Privilegios -->
        <div class="form-field full">
          <div class="privileges-header">
            <label class="form-label privileges-title">{{ labels.privilegios }}</label>
            <div class="select-all-container">
              <p-checkbox
                [(ngModel)]="allSelected"
                (onChange)="toggleAllPrivileges($event.checked)"
                inputId="marcarTodasEdicao"
                binary="true">
              </p-checkbox>
              <label for="marcarTodasEdicao" class="select-all-label">{{ labels.marcar_todas }}</label>
            </div>
          </div>

          <!-- Modulos agrupados por secao, na ordem em que as telas aparecem no menu -->
          <div class="privilege-sections">
            <div class="privilege-section" *ngFor="let secao of secoesPrivilegio">
              <span class="privilege-section-title">{{ secao.titulo }}</span>
              <div class="privilege-grid">
                <div class="privilege-item" *ngFor="let privilegio of secao.privilegios">
                  <p-checkbox
                    [(ngModel)]="selectedPrivilegios"
                    [binary]="false"
                    [value]="privilegio.janelaDeMenu.enum"
                    [inputId]="'priv-edicao-' + privilegio.janelaDeMenu.enum"
                    label="{{ privilegio.janelaDeMenu.nome }}">
                  </p-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Botoes de Acao -->
<div class="actions-container">
  <button pButton [label]="botoes.voltar" severity="secondary" icon="pi pi-arrow-left"
    routerLink="/privilegios-do-usuario" class="btn-secondary"></button>
  <button pButton [label]="botoes.salvar" icon="pi pi-check" (click)="submit()" class="btn-primary"></button>
</div>
